/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feSunrise', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherSunriseIconData */

/** @type {FeatherSunriseIconData} */
const feSunrise = {
  prefix: 'fe',
  iconName: 'sunrise',
  icon: [
    24,
    24,
    '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sunrise"><path d="M17 18a5 5 0 0 0-10 0"/><path d="M12 2 L12 9"/><path d="M4.22 10.22 L5.64 11.64"/><path d="M1 18 L3 18"/><path d="M21 18 L23 18"/><path d="M18.36 11.64 L19.78 10.22"/><path d="M23 22 L1 22"/><path d="M8 6 L12 2 L16 6"/></svg>',
    'M17 18a5 5 0 0 0-10 0 M12 2 L12 9 M4.22 10.22 L5.64 11.64 M1 18 L3 18 M21 18 L23 18 M18.36 11.64 L19.78 10.22 M23 22 L1 22 M8 6 L12 2 L16 6',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feSunrise
